import { Loading } from "@westpierstudio/core-module-oryx/services";
import { Json } from "@westpierstudio/luma/loading/types";
import Ammo from "ammojs-typed";

export class LuckyWealthCatLoading extends Loading {

    override async loadResourceStages(assets: Record<string, Record<string, string[]>>, splashScreen: boolean, settings: Json, textureScale: number, consolidatedJsons: Json[]) {
        await Promise.all([
            super.loadResourceStages(assets, splashScreen, settings, textureScale, consolidatedJsons),
            this.initialisePhysics()
        ]);
    }

    initialisePhysics() {
        // weird syntax. Top level Ammo object is an async function, which returns a promise with the API and assigns it to the argument object.
        // by passing the Top level Ammo as the argument, it assigns the API to the "global" Ammo so it behaves like a regular library after this
        // point.
        return Ammo(Ammo);
    }
}